import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const SettingsWhatsappPage = lazy(() => import("@/pages/settings.whatsapp.page"));

export const Route = createFileRoute("/settings/whatsapp")({
  component: SettingsWhatsappPage,
});
